module.exports = __webpack_public_path__ + "static/icon-a695932fcbbc5e8da5860166424659d7.png";